import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const Header = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h2 className="font-semibold text-2xl" data-testid="header-title">
        {t("dashboard.topup.landtech_balance")}
      </h2>
      <p className="text-base text-neutral-600" data-testid="header-subtitle">
        {t("dashboard.topup.balance_subtitle")}
      </p>
    </div>
  );
};
